<dx-popup
    #invoiceDetailPopup
    [title]="popUpTitle"
    [showTitle]="true"
    [minWidth]="'50%'"
    [minHeight]="'50%'"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="invoice-details-content">
        <dx-box *ngIf="!!invoiceDetails" width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <dx-form width="100%" height="100%" [readOnly]="true" [colCount]="3" [formData]="invoiceDetails">
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Customer Name"></dxo-label>
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                mode="hyperlinkOnly"
                                [displayText]="invoiceDetails?.name"
                                (onLinkClick)="onCustomerNameClick(invoiceDetails)"
                            ></app-hyperlink-creator>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="1" *ngIf="isInternalUser">
                        <div class="history-icon" *dxTemplate>
                            <dx-toolbar>
                                <dxi-item location="after">
                                    <div *dxTemplate>
                                        <dx-button
                                            [icon]="historyIcon"
                                            hint="Transaction History"
                                            (onClick)="onTransactionLogClick()"
                                        ></dx-button>
                                    </div>
                                </dxi-item>
                            </dx-toolbar>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Account ID"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.customerCode }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Document Number"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.documentNumber }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Document Type"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.documentType }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Document Date"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.documentDate | date: dateFormat }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.postDate | date: dateFormat }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Last Updated by"></dxo-label>
                        <div *dxTemplate>
                            <app-user-bio-link
                                [user]="invoiceDetails?.lastUpdate"
                                [communityId]="invoiceDetailParam?.communityId"
                            ></app-user-bio-link>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Charge"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.charge | ccCurrency }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Charge Due"></dxo-label>
                        <div *dxTemplate>
                            <ng-container
                                *ngIf="invoiceDetails?.charge > 0 && invoiceDetails?.chargeDue < invoiceDetails?.charge"
                            >
                                <app-hyperlink-creator
                                    [displayText]="invoiceDetails?.chargeDue | ccCurrency"
                                    (onLinkClick)="showARCreditApplication()"
                                ></app-hyperlink-creator>
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    invoiceDetails?.charge > 0 && invoiceDetails?.chargeDue === invoiceDetails?.charge
                                "
                            >
                                {{ invoiceDetails?.chargeDue | ccCurrency }}
                            </ng-container>

                            <ng-container
                                *ngIf="
                                    invoiceDetails?.charge < 0 &&
                                    invoiceDetails?.chargeDue >= invoiceDetails?.charge &&
                                    invoiceDetails?.chargeDue !== 0
                                "
                            >
                                <app-hyperlink-creator
                                    [displayText]="invoiceDetails?.chargeDue | ccCurrency"
                                    (onLinkClick)="showARManualCreditApplication()"
                                ></app-hyperlink-creator>
                            </ng-container>

                            <ng-container *ngIf="invoiceDetails?.charge < 0 && invoiceDetails?.chargeDue === 0">
                                <app-hyperlink-creator
                                    [displayText]="invoiceDetails?.chargeDue | ccCurrency"
                                    (onLinkClick)="showARCreditApplication()"
                                ></app-hyperlink-creator>
                            </ng-container>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Due Date"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.dueDate | date: dateFormat }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Sub Ledger"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.subLedger }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Supporting Document"></dxo-label>
                        <div *dxTemplate>
                            <div *ngIf="!!invoiceDetails?.supportDocument?.fileName">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="invoiceDetails?.supportDocument?.fileName"
                                    (onLinkClick)="downloadSupportDocument()"
                                ></app-hyperlink-creator>
                            </div>
                        </div>
                        <span *ngIf="!invoiceDetails?.supportDocument?.fileName">N/A</span>
                    </dxi-item>
                    <dxi-item>
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ invoiceDetails?.description }}</span>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="3">
                        <div *dxTemplate class="cc-text-required">
                            <ng-container *ngIf="!!invoiceDetails?.message">
                                <strong>Note:&nbsp;</strong>
                                {{ invoiceDetails?.message }}
                            </ng-container>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item [ratio]="1" class="invoice-details-datagrid-content">
                <cc-data-grid-features
                    [stateConfig]="{ storageKey: 'AR_INVOICE_DETAILS_GRID' }"
                    [gridFeatures]="{ placement: 'top', allowPlacementSwitch: false }"
                    [pagingConfig]="{ visible: false }"
                    [dataSource]="invoiceDetails?.items"
                >
                    <dx-data-grid
                        width="100%"
                        height="100%"
                        [showBorders]="true"
                        [showRowLines]="true"
                        [showColumnLines]="true"
                        [wordWrapEnabled]="true"
                        [rowAlternationEnabled]="false"
                        [columnAutoWidth]="true"
                        [dataSource]="invoiceDetails?.items"
                    >
                        <dxi-column
                            caption="Item #"
                            dataType="string"
                            alignment="right"
                            cellTemplate="itemNoTemplate"
                            width="4%"
                        ></dxi-column>
                        <dxi-column
                            caption="Account"
                            dataType="string"
                            cellTemplate="accountTemplate"
                            width="30%"
                        ></dxi-column>
                        <dxi-column
                            caption="Sub Category"
                            dataType="string"
                            dataField="subCategory"
                            width="10%"
                        ></dxi-column>
                        <dxi-column
                            caption="Amount"
                            dataType="number"
                            dataField="amount"
                            [format]="currencyFormat"
                            width="8%"
                        ></dxi-column>
                        <dxi-column
                            caption="Open Balance"
                            dataType="number"
                            dataField="openBalance"
                            [format]="currencyFormat"
                            width="8%"
                        ></dxi-column>
                        <ng-container *ngFor="let dim of invoiceDetails?.requiredDimensions">
                            <dxi-column
                                [caption]="dim.displayText"
                                dataType="string"
                                [dataField]="dim.key"
                            ></dxi-column>
                        </ng-container>
                        <ng-container *ngIf="hasOtherDimensions">
                            <dxi-column
                                caption="Other Dimensions"
                                dataType="string"
                                cellTemplate="dimensionTemplate"
                                width="15%"
                            ></dxi-column>
                        </ng-container>
                        <dxi-column
                            caption="Description"
                            dataType="string"
                            dataField="description"
                            width="15%"
                        ></dxi-column>
                        <div *dxTemplate="let row of 'itemNoTemplate'">
                            <span>{{ row.rowIndex + 1 }}</span>
                        </div>
                        <div *dxTemplate="let row of 'accountTemplate'">
                            <ng-container *ngIf="row.data.accountLabelTitle">
                                Account Label:
                                <strong>{{ row.data.accountLabelTitle }}</strong>
                                <br />
                                GL Account Number:
                                <strong>{{ row.data.glAccountNumber }}</strong>
                                <br />
                                Offset GL Account:
                                <strong>{{ row.data.offsetGLAccountNumber }}</strong>
                            </ng-container>
                            <ng-container *ngIf="!row.data.accountLabelTitle">
                                GL Account Number: {{ row.data.glAccountNumber }} -
                                <br />
                                <strong>{{ row.data.glAccountNumberTitle }}</strong>
                                <br />
                                Offset GL Account: {{ row.data.offsetGLAccountNumber }} -
                                <br />
                                <strong>{{ row.data.offsetGLAccountNumberTitle }}</strong>
                            </ng-container>
                        </div>
                        <div *dxTemplate="let row of 'dimensionTemplate'">
                            <ng-container *ngFor="let dim of row.data.dimensions">
                                <ng-container *ngIf="isNotRequiredDimension(dim)">
                                    {{ dim.dimensionTitle }}: {{ dim.dimensionOptionTitle }}
                                    <br />
                                </ng-container>
                            </ng-container>
                        </div>
                    </dx-data-grid>
                </cc-data-grid-features>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="after" [visible]="invoiceDetails?.allowReverse">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                template="reverseBtnTemplate"
                                text="Reverse"
                                (onClick)="onReverseClick()"
                            >
                                <div *dxTemplate="let btn of 'reverseBtnTemplate'" class="cc-button-template">
                                    <span>
                                        <i [ngClass]="iconReverse"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="PUT"
                                            apiUrl="api/cb/ar/invoice/reverse"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="invoiceDetails?.allowWaive">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                template="waiveBtnTemplate"
                                text="Waive"
                                (onClick)="onWaiveClick()"
                            >
                                <div *dxTemplate="let btn of 'waiveBtnTemplate'" class="cc-button-template">
                                    <span>
                                        <i class="fas fa-money-bill-wave"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="PUT"
                                            apiUrl="api/cb/ar/invoice/waive"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item
                        location="after"
                        [visible]="invoiceDetails?.allowWriteOff && invoiceDetails?.chargeDue > 0"
                    >
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                template="writeOffBtnTemplate"
                                text="Write Off"
                                (onClick)="onWriteOffClick()"
                            >
                                <div *dxTemplate="let btn of 'writeOffBtnTemplate'" class="cc-button-template">
                                    <span>
                                        <i [ngClass]="iconWriteOff"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="PUT"
                                            apiUrl="api/cb/ar/invoice/write-off"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                [icon]="printIcon"
                                text="Print"
                                (onClick)="onPrintClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="invoiceDetails?.allowEdit || invoiceDetails?.allowBasicEdit">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                [icon]="editIcon"
                                text="Edit"
                                (onClick)="onEditClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after" [visible]="invoiceDetails?.allowDelete">
                        <div *dxTemplate>
                            <dx-button
                                type="danger"
                                template="deleteBtnTemplate"
                                text="Delete"
                                (onClick)="onDeleteClick()"
                            >
                                <div *dxTemplate="let btn of 'deleteBtnTemplate'" class="cc-button-template">
                                    <span>
                                        <i [class]="deleteIcon"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="DELETE"
                                            apiUrl="api/cb/ar/invoice"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                [icon]="closeIcon"
                                text="Close"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#invoiceDetailPopup' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<app-waive-invoice-confirmation
    #waiveInvoiceConfirmation
    (onSuccess)="onWaiveSuccess($event)"
></app-waive-invoice-confirmation>

<app-ar-credit-application
    *ngIf="showCreditApplication"
    [visible]="showCreditApplication"
    [creditApplicationData]="creditApplicationData"
    [transactionType]="transactionType"
    [transactionId]="invoiceDetailParam.invoiceId"
    [communityId]="invoiceDetailParam.communityId"
    [managementCompanyId]="invoiceDetailParam.managementCompanyId"
    (onCreditApplicationClose)="closeCreditApplication($event)"
></app-ar-credit-application>

<app-ar-manual-credit-application
    *ngIf="showManualCreditApplication"
    [visible]="showManualCreditApplication"
    [transactionType]="transactionType"
    [transactionId]="invoiceDetailParam.invoiceId"
    [communityId]="invoiceDetailParam.communityId"
    [managementCompanyId]="invoiceDetailParam.managementCompanyId"
    (onManualCAEditorClose)="onManualCAEditorClose($event)"
></app-ar-manual-credit-application>

<app-write-off-invoice-confirmation
    *ngIf="showWriteOffInvoice"
    [visible]="showWriteOffInvoice"
    [invoiceDetails]="invoiceDetails"
    [invoiceId]="invoiceId"
    [invoiceDetailParam]="invoiceDetailParam"
    (onWriteOffInvoiceClose)="onWriteOffInvoiceClose($event)"
></app-write-off-invoice-confirmation>

<app-transaction-history
    *ngIf="displayTransactionLogPopUp"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    [communityId]="selectedContext?.communityId"
    (onTransactionLogClose)="displayTransactionLogPopUp = false"
></app-transaction-history>

<app-ar-invoice-reverse-editor
    *ngIf="showReverseEditor"
    [visible]="showReverseEditor"
    [invoiceDetails]="invoiceDetails"
    [invoiceDetailParam]="invoiceDetailParam"
    (onReverseEditorClose)="onReverseEditorClose($event)"
></app-ar-invoice-reverse-editor>

<app-ar-invoice-editor
    *ngIf="showInvoiceEditor"
    [visible]="showInvoiceEditor"
    [popUpTitle]="invoiceEditorPopupTitle"
    [invoiceEditorParam]="invoiceDetailParam"
    (onInvoiceEditorClose)="onInvoiceEditorClose($event)"
></app-ar-invoice-editor>
